export default __webpack_public_path__ + "static/indoor7-1f6aa93c0ef773a6cd7e34f6c4b53915.webp";